import { FC } from "react";

/**
 * English content for the Sports Betting Rules modal.
 */
const RulesContentEN: FC = () => {
  return (
    <div className="text-sm leading-relaxed text-gray-800 space-y-2">
      <section>
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Sports Betting Rules</h1>
        </div>

        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">A. BET TYPES</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. 1X2</h3>
          <ol>
            <li className="flex pt-2">
              <div>1.1</div>
              <div className="pl-3">
                Bets can be made by either selecting a Home Win, a Draw or an
                Away Win.
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                Bets will be settled at the end of normal time play, excluding
                extra time and penalties (where applicable).
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. ASIAN HANDICAP</h3>
          <ol>
            <li className="flex pt-2">
              <div>2.1</div>
              <div className="pl-3">
                Asian Handicap is a style of betting where the bookmaker
                handicaps the two teams in a game before its commencement. Using
                Football as an example, the bookmaker gives a goals deficit to
                the team it thinks is more likely to win, and a head start to the
                team it thinks is less likely to win. The handicaps are expressed
                in goals, or fractions of goals. To win a bet, the End User,
                rather than backing a team to win, bets on it to overcome the
                handicap.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. CORRECT SCORE - FIRST HALF &amp; FULL TIME</h3>
          <ol>
            <li className="flex pt-2">
              <div>3.1</div>
              <div className="pl-3">For First Half Correct Score:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Bets are made by predicting the correct result or score at
                the end of the first half of a match or event that is offered for
                betting.
              </li>
              <li className="pt-2 pl-3">
                (B) General Sports Rule No. 13 will be applied where the match or
                event is abandoned, suspended or postponed before the end of the
                first half.
              </li>
              <li className="pt-2 pl-3">
                (C) Bets are settled on the score of the match or event at the
                end of the first half, including added time for injury and
                stoppages.
              </li>
            </ol>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">For Full Time Correct Score:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Bets are made by predicting the correct result or score at
                the end of the match or event that is offered for betting.
              </li>
              <li className="pt-2 pl-3">
                (B) General Sports Rule No. 13 will be applied where the match or
                event is abandoned, suspended or postponed before the end of the
                match or event.
              </li>
              <li className="pt-2 pl-3">
                (C) Bets are settled on the final score of the match or event,
                including added time for injury and stoppages.
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. DOUBLE CHANCE</h3>
          <ol>
            <li className="flex pt-2">
              <div>4.1</div>
              <div className="pl-3">
                Double chance is similar to 1X2 bets except that the End User is
                able to bet on two out of three possible outcomes by selecting
                the following options: a Home Win or Away Win; a Draw or Away Win
                or a Draw or Home Win.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                If one of the two possible outcomes is achieved, the bet is won.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                If a match is played on neutral ground, the team listed first on
                the Website is deemed to be the home team for betting purposes.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. FIRST TO START</h3>
          <div className="pt-2">
            Predict the team or participant who starts off the
            game/match/event.
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. HALF TIME/FULL TIME</h3>
          <div className="pt-2">
            Bet on the half time and full time results of a designated match,
            (note that the bet is void if the match is played in a time format
            not expressly provided in the Specific Sports Betting Rules).
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. MIX PARLAY</h3>
          <div className="pt-2">
            A mix parlay bet is a bet which combines multiple selections of
            different games or matches offered by the bookmaker for betting. A
            mix parlay bet which combines different selections within the same
            game or match are not allowed where the outcome of one affects the
            other.
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. MONEY LINE /HEAD TO HEAD</h3>
          <div className="pt-2">
            A money line / Head to Head bet is a bet on the outcome of a match or
            event between two paired competitors. In the event of a draw result,
            all bets will be refunded at odds of 1.00.
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. NEXT GOAL</h3>
          <ol>
            <li className="flex pt-2">
              <div>9.1</div>
              <div className="pl-3">
                Predict the next team to score in a match within the regular
                playing time.
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                Own goals are counted in favor of the team credited with the
                goal.
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.3</div>
              <div className="pl-3">
                Bets will be refunded if the match is abandoned unless the result
                has been unconditionally determined.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">10. ODD/EVEN</h3>
          <div className="pt-2">
            Bets are settled based on the aggregate sum total of points/goals
            (resulting in an odd or even number) in a match or series of matches
            in which the bets were placed. A 0-0 score is considered as even.
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">11. OUTRIGHT</h3>
          <ol>
            <li className="flex pt-2">
              <div>11.1</div>
              <div className="pl-3">An outright bet involves the selection of:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) A winner in a tournament, competition, league, race, or event
                (“Sports Event”) (or any part or aspect thereof); or
              </li>
              <li className="pt-2 pl-3">
                (B) A team or individual competitor to place in a specific
                position or range of positions to be determined by the Operator,
                of a Sports Event (or any part or aspect thereof); or
              </li>
              <li className="pt-2 pl-3">
                (C) Two or more teams or individual competitors to place in a
                specific range of positions to be determined by the Operator, of
                a Sports Event (or any part or aspect thereof); either before the
                commencement or at any stage of the Sports Event (or any part or
                aspect thereof) prior to its conclusion where the results are
                still undecided.
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.2</div>
              <div className="pl-3">
                The following are some examples of the outright bets accepted by
                the Operator:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) <u>Final Outcome</u>
              </li>
              <li className="pt-2 pl-3">
                (B) <u>Regional Best Performer</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Bet on which team or individual competitor from a
                    particular region advances the furthest in a Sports Event (or
                    part or aspect thereof) (e.g. Top African Team, Top Asian
                    Team, Top European Team, Top North and Central American Team
                    and Top South American Team, etc)
                  </li>
                  <li className="pt-2 pl-3">
                    (II) If more than one team or individual competitor from the
                    same region exits the Sports Event in the same furthest round
                    or if all teams or individual competitors from the same
                    region are eliminated in the group stage or preliminary
                    rounds, the Dead Heat rule applies.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) <u>Group or Conference Winner</u>
              </li>
              <li className="pt-2 pl-3">
                (D) <u>Top Scorer</u>
              </li>
              <li className="pt-2 pl-3">
                (E) <u>Specific Position and Top Group Finisher</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) In a specific position other than the winner (e.g. Second
                    Place, Third Place, Semi Finalist, etc); or
                  </li>
                  <li className="pt-2 pl-3">
                    (II) within a selected range of positions (e.g, Top 2, 5, 10,
                    etc) without regard to the exact position of the team or
                    individual competitor in that Sports Event (or part or aspect
                    thereof).
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (F) <u>Place Forecasting</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Straight Forecast - within a selected range of positions
                    (e.g, Top 2, 5, 10, etc) in the correct order of positions at
                    the end of the Sports Event (or part or aspect thereof which
                    includes, but is not limited to the group or conference stage
                    of a Sports Event); or
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Dual Forecast - within a selected range of positions
                    (e.g, Top 2, 5, 10, etc) without regard to the exact position
                    of the team or individual competitor in that Sports Event (or
                    part or aspect thereof which includes, but is not limited to
                    the group or conference stage of a Sports Event).
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.3</div>
              <div className="pl-3">
                Outright bets may be offered either before the commencement or at
                any stage of the Sports Event prior to its conclusion where the
                results for that category of bets are still undecided.
              </div>
            </li>
            <li className="flex pt-2">
              <div>11.4</div>
              <div className="pl-3">
                There are no refunds on non-starters for outright betting.
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non-starter means a team or an individual competitor or a
                player who did not start a Sports Event notwithstanding the
                inclusion of its or his or her name in the final squad (e.g. Top
                Goalscorers).
              </li>
              <li className="pt-2 pl-3">
                (B) If a team, individual competitor or a player withdraws or
                retires or is disqualified prior to the commencement of a Sports
                Event, bets on that team, individual competitor or player will be
                refunded (unless otherwise stated in the Specific Sport Betting
                Rules).
              </li>
              <li className="pt-2 pl-3">
                (C) If any of the cases mentioned above involves a favorite team,
                individual competitor or player and it further affects the odds
                or payout of the outright bets for that Sports Event in general,
                then all outright bets on that Sports Event will be refunded
                accordingly.
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.5</div>
              <div className="pl-3">
                The Dead Heat Rule applies to all outright betting.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">12. OVER/UNDER</h3>
          <div className="pt-2">
            Bets are settled based on the aggregate sum total of points/goals etc
            achieved (resulting in an over or under of a prescribed target number
            set by the Operator) in a match or series of matches in which the
            bets were placed.
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">13. PERIOD BETTING</h3>
          <ol>
            <li className="flex pt-2">
              <div>13.1</div>
              <div className="pl-3">
                Period betting means the placing of a bet on different segments
                of a game (e.g. quarters, halves, periods, sets, rounds or
                overs).
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.2</div>
              <div className="pl-3">
                In Period betting, a segment must be completed in order for the
                bets to be valid.
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.3</div>
              <div className="pl-3">
                In Period betting, overtime or extra time is excluded in
                determining the scores if nothing else is stated.
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.4</div>
              <div className="pl-3">
                Subject to the Specific Sport Betting Rules, Period betting on the
                2nd half shall include overtime in determining the score.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">14. COMBO PARLAY</h3>
          <div className="pt-2">
            Combo parlay is a feature of mix parlay that gives you the
            convenience of placing multiple combinations of bets from the events
            you selected. To use the combo parlay feature, you need to select 3
            to 8 different events or matches offered for betting from the mix
            parlay market page. Multiple selections from the same event or match
            whereby the outcome of one affects the other is not allowed. The
            number of events you selected will affect the type of combo parlay
            feature that you can use. As an example, when you have selected 4
            events:
          </div>
          <ol type="1" className="pt-2">
            <li>
              1. <b>Event A</b> (Manchester City vs West Ham United)
            </li>
            <li>
              2. <b>Event B</b> (Cittadella vs Hellas Verona)
            </li>
            <li>
              3. <b>Event C</b> (Cordoba vs Osasuna)
            </li>
            <li>
              4. <b>Event D</b> (Liverpool vs Tottenham Hotspur)
            </li>
          </ol>
          <div className="py-3">From the events above, you can choose to use:</div>
          <div className="pl-4">
            <ul className="pb-3 list-disc">
              <li>
                <b>Double</b> (6 bets - 6 combinations of <b>AB</b>, <b>AC</b>,{" "}
                <b>AD</b>, <b>BC</b>, <b>BD</b>, and <b>CD</b>)
              </li>
              <li>
                <b>Treble</b> (4 bets - 4 combinations of <b>ABC</b>, <b>ABD</b>,{" "}
                <b>ACD</b>, and <b>BCD</b>)
              </li>
              <li>
                <b>4-Folds</b> (1 bet - 1 combination of <b>ABCD</b>)
              </li>
              <li>
                <b>Double</b>, <b>Treble</b>, and <b>4-Folds</b> (11 bets in
                total)
              </li>
            </ul>
          </div>
          <div className="pb-3 overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>NO. OF EVENTS SELECTED</th>
                  <th>DOUBLE</th>
                  <th>TREBLE</th>
                  <th>4-FOLDS</th>
                  <th>5-FOLDS</th>
                  <th>6-FOLDS</th>
                  <th>7-FOLDS</th>
                  <th>8-FOLDS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>3</td>
                  <td>3 bets</td>
                  <td>1 bet</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>6 bets</td>
                  <td>4 bets</td>
                  <td>1 bet</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>10 bets</td>
                  <td>10 bets</td>
                  <td>5 bets</td>
                  <td>1 bet</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>15 bets</td>
                  <td>20 bets</td>
                  <td>15 bets</td>
                  <td>6 bets</td>
                  <td>1 bet</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>21 bets</td>
                  <td>35 bets</td>
                  <td>35 bets</td>
                  <td>21 bets</td>
                  <td>7 bets</td>
                  <td>1 bet</td>
                  <td></td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>28 bets</td>
                  <td>56 bets</td>
                  <td>70 bets</td>
                  <td>56 bets</td>
                  <td>28 bets</td>
                  <td>8 bets</td>
                  <td>1 bet</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">15. ASIAN 1X2</h3>
          <div className="pt-2">
            In Asian 1X2, you can bet on either teams or on the draw outcome.
            When you place your bet, any existing goals prior to confirming your
            bet ticket will be offset.
            <br />
            If you are betting in European 1X2, you are only betting on the final
            outcome of the event.
            <br />
            As an example in the match between Japan and England, England is
            currently leading Japan by 0:1. (Referring to event above, 1 = Japan,
            X = Draw, and 2 = England.)
          </div>
          <div className="py-3">
            In the case if you place a bet on Japan in Asian 1X2.
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>Full Time Score (Japan vs. England)</th>
                  <th>Score when the bet is placed</th>
                  <th>Full Time Score (Japan vs. England)</th>
                  <th>Bet Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1 : 1</td>
                  <td>0 : 1</td>
                  <td>1 : 0</td>
                  <td>Win</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>Lose</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="py-3">
            In the case if you place a bet on <b>Draw</b> in Asian 1X2.
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>Full Time Score (Japan vs. England)</th>
                  <th>Score when the bet is placed</th>
                  <th>Full Time Score (Japan vs. England)</th>
                  <th>Bet Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>0 : 0</td>
                  <td>Win</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>Lose</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">B. GENERAL SPORTS RULES</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          Unless otherwise stated in the Specific Sports Betting Rules, the
          following General Sports Rules will apply:
        </div>

        <div className="pt-4">
          <h4 className="font-bold">1. APPLICABILITY OF THE RULES</h4>
          <div className="pt-2">
            All bets accepted by the Operator are subject to these Rules.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            2. INCONSISTENCY BETWEEN ENGLISH &amp; OTHER LANGUAGES
          </h4>
          <div className="pt-2">
            In the event of any inconsistency between the English and the
            Non-English names used on the Website, it is the English version that
            shall prevail.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">3. INTERPRETATION OF RULES</h4>
          <div className="pt-2">
            If there is any dispute over the interpretation of these Rules, it is
            the Operator's interpretation of these Rules that prevails.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">4. MODE OF BETTING</h4>
          <div className="pt-2">
            We only accept bets made on the Website, WAP or through prior
            arrangement by telephone.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">5. EVENT DETAILS</h4>
          <div className="pt-2">
            Event details (dates, neutral ground venue, commencement, timers, red
            cards, statistical information on players and teams or news)
            displayed on the Website (including details displayed in the Live
            Center) are for general information only. It is the responsibility of
            the End User to ensure and verify that such details are correct
            before placing their bets. The Operator is not responsible for any
            errors, mistakes, time lag, or omissions to any event details or
            video streams that are displayed or accessed on the Website.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">6. MAXIMUM BET</h4>
          <div className="pt-2">
            The maximum amount of each bet varies according to the specific bet
            type and is subject to change without prior notice by the Operator.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">7. CHANGE OF VENUE</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                In the event of a change of venue (home team plays away or vice
                versa), all bets on the match will be void.
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                If a match is scheduled to be played on neutral ground, but is
                played on non neutral ground (or vice versa) all bets shall
                stand.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">8. EARLY COMMENCEMENT/START</h4>
          <div className="pt-2">
            All bets placed before the scheduled games starts are valid. Those
            placed after the scheduled game starts will be void unless the bets
            were placed as part of the In Running ("Live") betting service.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">9. ODDS FLUCTUATIONS</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                All of the Operator's odds are subject to fluctuation at any time.
                Bets are valid only when the odds selected by the End User are
                submitted to and accepted by the Operator.
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                Should the odds selected by the End User change to better odds in
                favour of the End User between the submission of the bet and the
                acceptance thereof by the Operator, the End User's bet will be
                accepted at the better odds.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">10. ODDS TYPES</h4>
          <div className="pt-2">
            The Operator offers the following odds types for betting:
          </div>
          <ol type="A" className="pt-2">
            <li className="pt-2 pl-3">(A) European Odds</li>
            <li className="pt-2 pl-3">(B) Malay Odds</li>
            <li className="pt-2 pl-3">(C) Indo Odds</li>
            <li className="pt-2 pl-3">(D) Hong Kong Odds</li>
            <li className="pt-2 pl-3">(E) Myanmar Odds</li>
          </ol>
          <div className="pt-2 pb-2">
            For further information on the various odds type, please contact our
            customer service department or refer to our tutorial on the website.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">11. THE 72 HOURS RULE</h4>
          <div className="pt-2">
            All Results posted shall be final after 72 hours and no queries will
            be entertained after that period of time.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">12. CANCELLED EVENTS</h4>
          <div className="pt-2">
            If an event is cancelled for any reason prior to its commencement, all
            bets placed for that event will be void and will be returned at odds
            of 1.00.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            13. POSTPONED, SUSPENDED OR INCOMPLETE EVENTS (THE 12 HOUR RULE)
          </h4>
          <div className="pt-2">
            All bets placed will be refunded if an event is suspended or
            postponed, and not resumed within 12 hours from the scheduled
            commencement time (unless otherwise stated in the particular sport
            rule). The exception shall be for bets which have been
            unconditionally determined before the actual interruption of play. In
            such circumstances, such bets will be valid.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">14. SUSPENSION OF MARKETS</h4>
          <div className="pt-2">
            The Operator reserves the right to suspend a market or not accept bets
            at any time. When a market is suspended, any bets placed for that
            market but prior to being accepted by the Operator will be rejected.
            The Operator also reserves the right to cease betting on any markets
            at any time without notice.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">15. VOIDING BETS DUE TO MISTAKE OR ERROR</h4>
          <div className="pt-2">
            If an incorrect participant (or an incorrect member of a
            participating team) or incorrect odds/price is quoted for any event or
            the Operator has relied on incorrect information to compile its odds
            or bets or wrong scores or detail were entered during an In Running
            ("Live") Bets session or bets have been accepted in error, then the
            Operator reserves the right to void such or all bets placed for that
            event or on such participant.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">16. RETURNING STAKES DUE TO VOID BETS</h4>
          <div className="pt-2">
            All bets that have been declared void shall result in the original
            stake being returned.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">17. IRREGULAR BETS</h4>
          <div className="pt-2">
            The Operator reserves the right to refuse, reject or suspend without
            prior notification any End User who is suspected of cheating, hacking,
            attacking, manipulating or damaging the Operator's normal betting
            operations (including the Website). Any of the "abnormal bets" will be
            void without prior notification. The use of artificial intelligence or
            "bots" on the Website is strictly forbidden. The Operator will take
            measures to prevent and detect programmes that are used to enable
            artificial intelligence (non human) to utilise the Website. Any
            attempted or actual use of artificial intelligence by the End User to
            cheat, hack, attack, manipulating or damage the Operator's betting
            operations will lead to termination of their account and/or voiding
            the bets, at the discretion of the Operator
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">18. INCOMPLETE MIX PARLAY BETS</h4>
          <div className="pt-2">
            If an event or game in a mix parlay bet is cancelled, does not take
            place or is not completed for any reason, the cancelled/non-
            participating element of the bet shall be void but the remaining
            elements of the mix parlay bet shall stand with the odds recalculated.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">19. DETERMINATION OF BETS</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>19.1</div>
              <div className="pl-3">
                The winner of an event will be determined based on the relevant
                results at the conclusion of the event. The determination and
                settlement of the winner of an event and the determination and
                settlement of all bets, based on the bet types and the terms and
                conditions in relation to the bet type concerned, shall be made at
                the conclusion of the event and after all relevant results have
                been checked and verified. The Operator shall use its best
                endeavors to check and verify all relevant results as soon as may
                be reasonable after the conclusion of the event. Once the relevant
                results are checked, verified and posted, any subsequent
                protested, appealed or overturned decisions will not be recognized
                for wagering purposes.
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.2</div>
              <div className="pl-3">
                Notwithstanding any rule stated in the Specific Sports Betting
                Rules, the Sports Betting Rules and these General Sports Rules, the
                Operator may in its sole discretion effect determination and/or
                settlement of any bet or bets based on its (their) bet type(s) and
                the terms and conditions in relation to that (those) bet type(s),
                at any time, and from time to time, prior to the conclusion of any
                game/match/event if such bet or bets can be unconditionally
                determined at the time of such determination by the Operator.
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.3</div>
              <div className="pl-3">
                Nothing in Clauses 19.1 and/or 19.2 above shall affect the rights
                of the Operator to treat any determined and/or settled bets as
                incorrectly determined and/or settled. Such incorrect
                determination and/or settlement shall be invalid and reversed by
                the Operator whereupon the Operator shall re-determine and/or
                re-settle these affected bets in accordance with the Operator's
                applicable terms and conditions.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">20. THE DEAD HEAT RULE</h4>
          <div className="pt-2">
            If there are two or more winners, the payout odds (less the stake) are
            divided by the number of winners and settled accordingly with the
            stake returned.
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">21. FANTASY MATCHES</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>21.1</div>
              <div className="pl-3">
                Fantasy match bets involve the virtual pairing of any two teams.
                Fantasy match results are decided by the number of goals/points
                scored by the two paired teams in their respective matches. The
                winning team is the team with the highest number of goals/points
                scored, inclusive of handicap, if any.
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.2</div>
              <div className="pl-3">
                Teams that are paired in a fantasy match must start their
                respective matches on the same day although one match may end
                later than the other but both matches must be played in one
                continuous session (i.e. no postponed, rescheduled or abandoned
                matches) for the bets to be valid.
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.3</div>
              <div className="pl-3">
                Subject to Rule 19.2 above, if any of the paired teams' matches
                are postponed, rescheduled or abandoned, all fantasy match bets
                involving those teams will be void.
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.4</div>
              <div className="pl-3">
                Venue (Home or Away) of the matches are not considered in these
                Fantasy matches.
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.5</div>
              <div className="pl-3">
                Except as provided above, Fantasy match rules will follow the
                rules of the particular sport in which fantasy match bets are
                offered.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            22. INCONSISTENT RESULTS/SCORES WITH OFFICIAL RESULTS
          </h4>
          <ol className="pt-2">
            <li className="flex">
              <div>22.1</div>
              <div className="pl-3">
                Where there is a conflict between the official match results and
                the results on the Operator's website, the Operator reserves the
                right to suspend determination and/or settlement of such bets for
                up to 72 hours or such other period necessary pending its
                verification of the result/score.
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.2</div>
              <div className="pl-3">
                The conflict shall be resolved by reference to video recordings of
                the match/event and any determination of the correct score/result
                based on such video recordings shall override the official match
                result.
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.3</div>
              <div className="pl-3">
                Where there is no video recording available, the correct
                score/result shall be determined by reference to the score/result
                posted on the official website of the sport governing body unless
                the official website's posted result is manifestly wrong, in which
                case the Operator shall use its best endeavours to determine the
                correct outcome to be used to determine the winner and/or the
                result. In such cases, the Operator's decision shall be final.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">23. IN RUNNING ("LIVE") BETS SERVICE</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>23.1</div>
              <div className="pl-3">
                In Running ("Live") bets are only available for those sports that
                the Operator designates as live betting markets and only in
                respect of those matches marked as "live" or "live bets" or by a
                LIVE sign in the list of events or in a special file entitled
                "LIVE" on the Website.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.2</div>
              <div className="pl-3">
                An In Running ("Live") bet is where the End User is permitted to
                place a bet during an ongoing match or event up to such time when
                the Operator ceases betting on that match or event.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.3</div>
              <div className="pl-3">
                In an In Running ("Live") Bet for Asian Handicap bets, two types
                of scoring systems are displayed on the Website:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) where current scores or results are updated and displayed
                ("Type A Scoring"). The settlement of a bet is determined by the
                result of the final score (including the handicap) at the
                conclusion of the match or Period Betting (depending on the nature
                of the bet), minus the current score at the time of the placing
                and acceptance of the bet.
              </li>
              <li className="pt-2 pl-3">
                (B) where current scores or results are not displayed and instead
                a 0-0 score or result will be displayed ("Type B Scoring"). The
                settlement of a bet is determined by the result of the final score
                (including the handicap) at the conclusion of the match or Period
                Betting (depending on the nature of the bet). The End User is
                advised to verify match status before placing their bet.
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.4</div>
              <div className="pl-3">
                Depending on the specific sport, selected markets may be offered
                for betting at the sole discretion of the Operator. The Operator
                does not acknowledge or accept any liability whatsoever if it is
                not possible to place a bet or if the live score update is
                incorrect. It is the scores or results displayed at the conclusion
                of the match that are valid.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.5</div>
              <div className="pl-3">
                At all times, it is the End User's responsibility to be aware
                about the score and is advised to verify match status before
                placing their bets.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.6</div>
              <div className="pl-3">
                Unless otherwise stated in the Specific Sports Betting Rules, any
                information, statistic or editorial text (e.g. scores, timers or
                results) displayed on the website during an In Running ("Live")
                game situation are purely for general information purposes and
                should not be relied upon for betting purposes.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.7</div>
              <div className="pl-3">
                As with non-live bets, the winner of an event will be determined
                based on the relevant results at the conclusion of the event.
                Protested, appealed or overturned decisions will not be
                recognized for wagering purposes and subsequent changes to the
                results will not affect the outcome of the bet.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.8</div>
              <div className="pl-3">
                The Operator reserves the right to suspend a market or not accept
                bets at anytime without notice. When a market is suspended any
                bets placed for that market but prior to being accepted by the
                Operator may be rejected at the Operator's discretion. Any bets
                accepted prior to suspension or cessation of the live market will
                stand, while any bets placed after live betting has ceased will
                not be accepted unless otherwise stated in the Specific Sports
                Betting Rules.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.9</div>
              <div className="pl-3">
                During In Running ("Live") bet conditions:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) bets placed will be kept in pending mode:
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) when the Operator is of the view that there may be an
                    occurrence of a high risk / danger moment; or
                  </li>
                  <li className="pt-2 pl-3">
                    (II) before and during a high risk / danger moment in a
                    match.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) bets referred to in Rule B23.9(a) above will be indicated as
                "Pending" on each bet slip until such time when the bet is
                accepted or rejected by the Operator in the Operator's sole
                discretion.
              </li>
              <li className="pt-2 pl-3">
                (C) High Risk / Danger moments are defined as follows:
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Corner kicks;</li>
                  <li className="pt-2 pl-3">(II) Penalty kicks;</li>
                  <li className="pt-2 pl-3">
                    (III) a free kick is awarded to the attacking team close to
                    the opponent's penalty box area;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) a throw in is given to the attacking team close to the
                    opponent's penalty box area;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) whenever a team is in a potential scoring scenario as in
                    an active attacking mode; or
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) as may be decided by the Operator in its sole
                    discretion.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (D) all Fast Market bets will not be subject to Rules B23.9 (a)
                to (c) above where such bets will be accepted without being kept
                in pending mode.
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.10</div>
              <div className="pl-3">
                All bets on Asian Handicap and Over/Under that are in Pending
                mode (other than bets on Total Bookings, Total Corners, Total
                Offsides, Total Substitutions and/or bets which do not have an
                effect on the overall result of the match) will be cancelled if
                one of the following occurs:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) a goal is scored; or</li>
              <li className="pt-2 pl-3">(B) a player is sent off.</li>
            </ol>
            <li className="flex pt-2">
              <div>23.11</div>
              <div className="pl-3">
                All other bets such as Total Bookings, Total Corners, Total
                Offsides, Total Substitutions and/or bets which do not have an
                effect on the overall result of the match may be accepted at the
                Operator's discretion.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.12</div>
              <div className="pl-3">
                The Operator at its sole discretion shall determine the time in
                which any goal or point was scored. References as to the time of
                goal(s) or points scored as stated in official league/club
                website, media website or "live score" website may be considered
                for guidance purposes but shall not be binding on the Operator in
                its determination of time.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.13</div>
              <div className="pl-3">
                Where the Operator has reason to believe or suspect that a live
                bet has been placed after the outcome of a live event is known or
                if delayed "live" television coverage results in a live bet being
                placed at the incorrect price after the selected participant has
                gained an advantage (to be determined at the Operator's sole
                discretion), the Operator shall be entitled to treat the bet as
                void without having to provide any reason whatsoever.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.14</div>
              <div className="pl-3">
                In the event of any technical malfunction, including the crashing
                of the Website or any downtime which hinders, delays or prevents
                the Operator from accessing the Website to update the score, odds
                or handicap, the Operator reserves the right to cancel all
                pending bets placed at the time of the incident.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.15</div>
              <div className="pl-3">
                With regard to live betting, the general rules concerning
                results' evaluation apply. Where a live event is interrupted in
                the course of play, causing the event to be postponed or
                abandoned, any bets taken on such postponed or abandoned events
                that are not restarted within 12 hours from the event
                commencement time (unless specifically provided for in the
                Specific Sports Betting Rules) shall be void. The exception shall
                be for bets which have been unconditionally determined before the
                actual interruption of play. In such circumstances, such bets
                will be valid.
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.16</div>
              <div className="pl-3">
                In Running ("Live") Mix Parlay. A Live mix parlay bet is a mix
                parlay bet that is combined from a selection of Live and non-Live
                bets and where at least 1 of the games or matches must be a Live
                event. A Live mix parlay bet must also be combined from a
                selection of at least 3 different games or matches. All
                selections must be accepted in order for the Live mix parlay bet
                to be valid. A rejection of any of the selections will result in
                the Live mix parlay bet being rejected as well.
              </div>
            </li>
          </ol>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">C. SPECIFIC SPORT BETTING RULES</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          The following rules are the special betting rules applicable to the
          bets placed on the individual sports and together with the general
          sports rules govern the End User's use of all the Operator's
          interactive sports betting products.
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. BASKETBALL</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>1.1</div>
              <div className="pl-3">
                For bets to be valid there must be 5 minutes or less of scheduled
                game time left when the remainder of the game is called off, with
                the exception of bets which have been unconditionally determined
                before the game is called off (e.g. Period Betting).
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                Settlement will be based on the official final score including
                Overtime (if applicable), unless otherwise specified.
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.3</div>
              <div className="pl-3">
                For NCAAB, the "Home" and "Away" venue indicated on the Website
                is for reference only.
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.4</div>
              <div className="pl-3">These are the bets offered for Basketball:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                  <li className="pt-2 pl-3">
                    (II) First To Score
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets will be settled based on the team to score the
                        first point in the match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If the match is abandoned after first point is scored,
                        all bets will be stand
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) Highest Scoring Team per Quarter
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the team with the highest scoring points for
                        each quarter of the match, excluding overtime.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) Last To Score
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets will be settled based on the team to score the
                        last point in the match (including any points scored in
                        overtime play).
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If the match is abandoned all bets on Last To Score
                        will be void.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(V) Odd/Even</li>
                  <li className="pt-2 pl-3">(VI) Outright</li>
                  <li className="pt-2 pl-3">(VII) Over/Under</li>
                  <li className="pt-2 pl-3">
                    (VIII) Period Betting
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Halves Betting
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) In respect of 1st half betting, bets are settled
                            based on the sum of the 1st and 2nd quarters' scores
                            inclusive of the handicap to determine the winner.
                          </li>
                          <li className="pt-2 pl-3">
                            (2) In respect of 2nd half betting, bets are settled
                            based on the sum of the 3rd and 4th quarters' scores
                            inclusive of the handicap to determine the winner. 2nd
                            half betting includes scores achieved in overtime (if
                            applicable).
                          </li>
                        </ol>
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Quarters Betting
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) Bets are settled based on the scores achieved at
                            the conclusion of each quarter inclusive of the
                            handicap to determine the winner.
                          </li>
                          <li className="pt-2 pl-3">
                            (2) For 4th quarter betting, goal or points scored in
                            overtime play are excluded in determining the winner.
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) Race to 20
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the team to reach the first 20 points in the
                        match.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) Total Points/ Rebounds/ Assists/ Steals/ Blocked Shots/ 3
                    Pointers by team/player:
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Settlement is based on player's or team's statistics
                        in that particulars match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Bets will be refunded on Non-Starters (i.e. players
                        who did not participate in any part of the match).
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Bets on players who played but did not score a point,
                        rebound or assist will be deemed to have scored zero.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                  <li className="pt-2 pl-3">(II) Over/Under</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) Scoring System
                <div className="pt-1">
                  Type B Scoring applies The live score board displayed on the
                  Mobile Site is solely for reference purposes only. The
                  settlement of bets shall be determined by the Type B Scoring
                  System.
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>1.5</div>
              <div className="pl-3">e-Basketball Betting</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Unless otherwise stated in this Rule 8.5, Rule 8 shall apply
                to e-Basketball bets.
              </li>
              <li className="pt-2 pl-3">
                (B) e-Basketball matches are simulations based on Artificial
                Intelligence, machine learning and historical basketball
                databases to reflect the team form and match play.
              </li>
              <li className="pt-2 pl-3">
                (C) Unless otherwise stated, each match is played in four quarters
                of 12 minutes each for a total match play time of 48 minutes.
              </li>
              <li className="pt-2 pl-3">
                (D) The e-Basketball match results, scores and other bet
                determining data shall be those produced by the software and not
                available from any other source including from official team or
                league websites.
              </li>
              <li className="pt-2 pl-3">
                (E) e-Basketball matches are broadcast matches and as such are
                considered Common Betting matches where more than one End User is
                able to bet on a specific match and the result of this match will
                determine the outcome of bets placed by all End Users.
              </li>
              <li className="pt-2 pl-3">
                (F) Where any match is not completed within the scheduled time due
                to a technical malfunction of any sort, including but not
                exclusively computer, electronic, software, hardware or connection
                malfunctions, the match shall be settled by the Operator as being
                incomplete. In such cases only those bets that have been
                unconditionally determined shall be settled. For all other markets
                and irrespective of any indicative results, the bets shall be void
                and the stakes returned to the End User. The Operator shall settle
                such matches in accordance with these rules and the Operator's
                decision shall be final.
              </li>
              <li className="pt-2 pl-3">
                (G) The Operator reserves the right to declare an e-Basketball bet
                to be void if;
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) only partial or incorrect bet details are available;
                  </li>
                  <li className="pt-2 pl-3">
                    (II) the Operator has any suspicion that one or more End Users
                    are participating in fraud, collusion, money laundering or
                    other illegal activities;
                  </li>
                  <li className="pt-2 pl-3">
                    (III) the match did not commence or was not completed or the
                    result could not be determined;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) acceptance of the bet would exceed any betting limits;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) the stake amount is not available in the End User's
                    account;
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) an error (human or otherwise) or system failure results
                    in incorrect odds being used;
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) technical faults such as communication failures,
                    defects, interruptions, delays, viruses, denial of service
                    attacks, or data corruption occur; or
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) if a technical defect produces excessive or irregular
                    winnings.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) Should a bet be settled incorrectly due to error (human or
                otherwise) or system failure, the settlement will be deemed as
                invalid and will be reversed. Should the End User have
                insufficient funds in their account to allow this, the End User
                will be required to return the necessary amount to the Operator.
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. BOXING</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>2.1</div>
              <div className="pl-3">
                For betting purposes, the disqualification of a boxer during a
                match will be counted as a knockout by his opponent.
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.2</div>
              <div className="pl-3">
                If a fighter fails to answer the bell for the start of a round, or
                is disqualified between rounds, then his opponent will be deemed to
                have won in the previous round.
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.3</div>
              <div className="pl-3">These are the bets offered for Boxing:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                  <li className="pt-2 pl-3">
                    (II) Odd/Even
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Odd/Even bets relate to the round in which the winner
                        is declared in the match (whether an odd or even number)
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Over/Under bets relate to the round in which the
                        winner is declared in the match (resulting in an over or
                        under a prescribed target round set by the Operator) for
                        the match.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. BASEBALL</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>3.1</div>
              <div className="pl-3">
                All baseball betting is offered on the basis of both listed
                pitchers starting the game. Both pitchers must start the game and
                throw at least one pitch for bets to be valid. If either pitcher
                fails to start the game for any reason, all bets placed for that
                event will be VOID and will be returned at odds of 1.00.
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">
                Where we do not name a pitcher next to a team then bets accepted
                on that team will stand regardless of the starting pitcher.
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.3</div>
              <div className="pl-3">
                The results of the game will be based on the official result,
                including extra innings (where applicable) at the conclusion of
                the game.
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.4</div>
              <div className="pl-3">
                International Baseball Rules: The game will end early if one team
                is leading the other by 10 runs or more after the opposing team
                has batted at least 7 innings or if a team is leading by 15 runs
                or more after the opposing team has batted at least 5 innings. In
                such event, all bets are considered valid.
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.5</div>
              <div className="pl-3">
                Japanese Baseball Rules: If a match is declared a draw after 12
                innings, all bets are considered valid. Japanese Baseball Rules
                applies only to Japanese Baseball Leagues.
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.6</div>
              <div className="pl-3">These are the bets offered for Baseball:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For Full Time Asian Handicap bets, all bets will be
                        VOID if less than 9 innings are played, except where the
                        home team is leading after 8½ innings when the game is
                        prematurely ended.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Money Line Bets
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets will be VOID if less than 5 innings are
                        played, except where the home team is leading after 4½
                        innings when the game is prematurely ended.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) Outright</li>
                  <li className="pt-2 pl-3">
                    (IV) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For Full Time Over/Under bets, all bets will be VOID
                        if less than 9 innings are played, except where the home
                        team is leading after 8½ innings when the game is
                        prematurely ended.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) Period Betting
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 1st Five Inning Bets (F5 betting)
                      </li>
                      <li className="pt-2 pl-3">
                        (B) All bets are settled on the basis of the score at the
                        end of 1st Five innings. If a game does not reach five
                        full innings, all 1st Five inning bets will be cancelled.
                        The rules on Full Time Asian Handicap and Full Time
                        Over/Under bets do not apply to 1st Five innings bets.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets will be VOID if less than 9 innings are
                        played, except where the home team is leading after 8½
                        innings when the game is prematurely ended.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets will be VOID if less than 9 innings are
                        played, except where the home team is leading after 8½
                        innings when the game is prematurely ended.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) Scoring System
                <div className="pt-1">Type A Scoring applies</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. CRICKET</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>4.1</div>
              <div className="pl-3">
                All match betting will be settled in accordance with official
                competition rules. Where matches are affected by adverse weather,
                bets will be settled according to the official match result. If
                there is no official match result, all bets will be void.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                The Cricket dead heat rules are where there is a minimum of two
                competitors/teams being declared as the winner (a dead heat), the
                number of paying places remaining after clear winners are settled
                will be divided by the number of competitors/teams sharing those
                places. The odds for the selection are then multiplied by the
                resulting value.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                In the case of a tie, if the official Sports Event rules do not
                determine a winner then the Cricket dead heat rules will apply.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.4</div>
              <div className="pl-3">
                Unless otherwise stated, in Sports Events where a bowl off or
                super over determines a winner, bets will be settled on the
                official match result.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.5</div>
              <div className="pl-3">
                If a match is abandoned due to external factors, then bets will be
                void unless a winner is declared based on the official Sports
                Event rules.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.6</div>
              <div className="pl-3">
                If a match is cancelled then all bets will be void if it is not
                replayed or restarted within 36 hours of its advertised start
                time.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.7</div>
              <div className="pl-3">
                For first-class matches, bets will be void if fewer than 200 overs
                have been bowled, unless settlement of any bet can be made because
                the outcome of the bet has already been determined.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.8</div>
              <div className="pl-3">
                In limited overs matches, bets will be void if it has not been
                possible to complete at least 80% of the scheduled overs in either
                innings due to external factors, including but not limited to bad
                weather, unless settlement of any bet can be made because the
                outcome of the bet has been determined before the reduction.
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.9</div>
              <div className="pl-3">
                These are the bets offered for Cricket Non Live and In Running
                ("Live") Betting:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Match, Team and Player Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 1X2
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For first-class matches, if the official result is a
                        tie, bets will be settled based on the Cricket dead heat
                        rules between both teams. Bets on the draw will be settled
                        as losers.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(II) Boundary in Over</li>
                  <li className="pt-2 pl-3">
                    (III) Coin Toss Winner
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) If no toss takes place, all bets will be void.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(IV) Dismissal Method</li>
                  <li className="pt-2 pl-3">(V) Dismissal per Overs / Innings</li>
                  <li className="pt-2 pl-3">(VI) Double chance</li>
                  <li className="pt-2 pl-3">
                    (VII) Draw No Bet
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For first-class matches, a tie will be settled based
                        on the Cricket dead heat rules.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VIII) Highest Individual Score</li>
                  <li className="pt-2 pl-3">
                    (IX) Highest Opening Partnership
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets will be based on the Runs in Opening
                        Partnership's.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) Man / Player of the Match
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets will be settled on the officially declared Man or
                        Player of the match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If no Man or Player of the match is officially
                        declared then all bets will be void.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XI) Match Ducks / Total Ducks
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) A duck is classed as a batsman being dismissed for
                        zero runs.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) For settlement purposes, a retired hurt batsman does
                        not count as a dismissal.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Ducks in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XII) Match Extras / Total Extras
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All wide deliveries, no balls, byes, leg byes and
                        penalty runs in the match count towards the final result.
                        If there are runs off the bat as well as extras from the
                        same delivery, the runs off the bat do not count towards
                        the final total.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Extras in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIII) Match Fours / Total Fours
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Only fours scored from the bat (off any delivery -
                        legal or not) will count towards the total fours.
                        Overthrows, all run fours and extras do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Fours scored in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIV) Match Run Outs / Total Run Outs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Run outs in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XV) Match Sixes / Total Sixes
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Only sixes scored from the bat (off any delivery -
                        legal or not) will count towards the total sixes.
                        Overthrows and extras do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Sixes scored in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVI) Match Wides / Total Wides
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Any runs resulting from a wide delivery, except
                        penalty runs, will count towards the final total.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Wides in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVII) Match Wickets / Total Wickets
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets are accepted on the total number of wickets that
                        will fall in a match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) For settlement purposes, a batsman who retires hurt
                        does not count as a wicket.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Wickets in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVIII) Maximum Over in Match
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Predict the runs to be scored in the highest scoring
                        over in the match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) All runs, including extras, count towards settlement.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Super overs do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIX) Most Catches
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets on the team which will take the most catches,
                        including catches by fielders and the wicket keeper.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) For first-class matches, only catches in the first
                        innings will count.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Catches taken in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XX) Most Extras
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All wide deliveries, no balls, byes, leg byes and
                        penalty runs in the match count towards the final result.
                        If there are runs off the bat as well as extras from the
                        same delivery, the runs off the bat do not count towards
                        the final total.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Extras in a super over do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, only first innings extras
                        will count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXI) Most Fours
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Only fours scored from the bat (off any delivery -
                        legal or not) will count towards the total fours.
                        Overthrows, all run fours and extras do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Fours scored in a super over do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, only first innings fours will
                        count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXII) Most Keeper Catches
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) If a team changes their wicket keeper mid innings, the
                        catches taken by the replacement will count towards
                        settlement.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Catches taken in a super over do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, only first innings catches
                        will count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIII) Most Sixes
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Only sixes scored from the bat (off and delivery -
                        legal or not) will count towards the total sixes.
                        Overthrows and extras do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Sixes scored in a super over do not count.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, only first innings sixes will
                        count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIV) Most Stumpings
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For first-class matches, only first innings stumpings
                        will count.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) Stumpings taken in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XXV) Outright</li>
                  <li className="pt-2 pl-3">(XXVI) Over / Under</li>
                  <li className="pt-2 pl-3">
                    (XXVII) Player Head to Head
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) If the player does not bat or bowl, but is in the
                        starting eleven, all bets will still be valid. If the
                        player is not in the starting eleven, bets will be void.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) The result will be considered determined if the line
                        at which the bet was placed is passed.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, only first innings will
                        count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXVIII) Player Performance
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) These markets use a points based scoring system to
                        determine their outcome. It is a composite score with 1
                        point per run, 20 points per wicket, 10 points per catch
                        and 25 points per stumping.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIX) Rabbit Runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the total runs scored by the number 11 batsman
                        in a match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) The number 11 batsman is taken to be last player to
                        come out to bat in the innings, regardless of the
                        previously stated order. If more than 11 players bat, all
                        bets on that market will be void.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) If the innings is completed without the number 11
                        batsman coming to the crease, that batsman will be deemed
                        to have scored zero (0).
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXX) Runs in First Over
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) The first over must be completed for bets to stand
                        unless settlement of any bet can be made because the
                        outcome of the bet has already been determined.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If an innings ends during an over then that over will
                        be deemed to be complete unless the innings is ended due
                        to external factors, including but not limited to bad
                        weather, in which case all bets will be void, unless
                        settlement of any bet can be made because the outcome of
                        the bet has already been determined.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, the market refers only to
                        each team's first innings.
                      </li>
                      <li className="pt-2 pl-3">
                        (D) Extras and penalty runs in the particular over will
                        count towards settlement.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXI) Runs in Opening Partnership
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) If the batting team reaches the end of their allotted
                        overs or reaches their target runs or declares before the
                        first wicket falls, the result will be the total runs
                        amassed.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) The result will be considered determined if the lines
                        at which the bet was placed is passed, or if a wicket has
                        fallen.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For settlement purposes, a batsman retiring hurt does
                        not count as a wicket.
                      </li>
                      <li className="pt-2 pl-3">
                        (D) For first-class matches, the market refers only to
                        each team's first innings.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXII) Runs in Groups of Overs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) If the specified number of overs are not complete the
                        bet will be void, unless the team is all out or declares
                        or reaches their run target or settlement of any bet can
                        be made because the outcome of the bet has already been
                        determined before the reduction.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) For first-class matches, the market only refers to the
                        first innings.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIII) Runs off First Delivery
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For settlement purposes, all illegal balls count as
                        deliveries. If the over starts with a wide, then first
                        delivery will be settled as 1 and, although there has not
                        been a legal ball bowled, the next ball will be deemed as
                        delivery 2 for that over.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If the delivery leads to a free hit, the runs scored
                        off the additional delivery do not count. All runs,
                        whether off the bat or not are included. For example, a
                        wide with three extra runs taken equates to 4 runs in
                        total off that delivery.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For first-class matches, the market refers only to
                        each team's first innings.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIV) Team to Finish with a Boundary
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXV) Team with Highest Score at each Dismissal
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVI) Team with Highest Scoring Over
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVII) Tied Match
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) For first-class matches, a tie is when the side
                        batting in the fourth innings is bowled out when the
                        scores are level.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVIII) Top Batsman / Team with Top Batsman
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Predict the batsman with the highest individual score
                        in a match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) In limited overs matches, bets will be void if has not
                        been possible to complete at least 50% of the overs
                        scheduled to be bowled in each innings at the time the bet
                        was placed due to external factors, including but not
                        limited to bad weather.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Top batsman bets for first-class matches apply only to
                        the first innings of each team, and will be void if fewer
                        than 200 overs have been bowled, unless both first innings
                        have been completed.
                      </li>
                      <li className="pt-2 pl-3">
                        (D) If a batsman was named at the toss, but later is
                        removed as a substitute, that batsman will still be
                        counted, as will the replacement batsman.
                      </li>
                      <li className="pt-2 pl-3">
                        (E) When two or more batsmen score the same number of
                        runs, the Cricket dead heat rules will apply.
                      </li>
                      <li className="pt-2 pl-3">
                        (F) Runs scored in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIX) Top Bowler / Team with Top Bowler
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Predict the bowler with the most wickets in a match.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) In limited overs matches, bets will be void if it has
                        not been possible to complete at least 50% of the overs
                        scheduled to be bowled in each innings at the time the bet
                        was placed due to external factors, including but not
                        limited to bad weather.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) Top bowler bets for first-class matches apply only to
                        the first innings of each team, and will be void if fewer
                        than 200 overs have been bowled, unless both first innings
                        have been completed.
                      </li>
                      <li className="pt-2 pl-3">
                        (D) If a bowler was named at the toss, but later is removed
                        as a substitute, that bowler will still be counted, as
                        will the replacement bowler.
                      </li>
                      <li className="pt-2 pl-3">
                        (E) If two or more bowlers have taken the same number of
                        wickets, the bowler who has conceded the fewest runs will
                        be the winner. If the same number of wickets are taken and
                        runs conceded, the Cricket dead heat rules will apply.
                      </li>
                      <li className="pt-2 pl-3">
                        (F) Wickets taken in a super over do not count.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XL) Total at each Dismissal</li>
                  <li className="pt-2 pl-3">(XLI) Total Dismissals</li>
                  <li className="pt-2 pl-3">
                    (XLII) Total in the Highest Scoring Over
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIII) Total Runs per Over / Innings
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIV) Wickets in Groups of Overs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bets refer to the wickets that will fall in a
                        specified number of overs.
                      </li>
                      <li className="pt-2 pl-3">
                        (B) If the specified number of overs are not complete the
                        bet will be void, unless the team is all out or declares
                        or reaches their run target or settlement of any bet can
                        be made because the outcome of the bet has already been
                        determined.
                      </li>
                      <li className="pt-2 pl-3">
                        (C) For settlement purposes, if a batsman is timed out or
                        retired out then the wicket is deemed to have taken place
                        on the previous ball. For the purposes of settlement, a
                        batsman who retires hurt does not count as a dismissal.
                      </li>
                      <li className="pt-2 pl-3">
                        (D) For first-class matches, the market refers only to
                        each team's first innings.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>4.10</div>
              <div className="pl-3">
                The Scoring System applicable to bets for Cricket is the Type B
                scoring.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. FOOTBALL</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>5.1</div>
              <div className="pl-3">
                Unless otherwise stated in these Football Betting Rules, all bets
                are settled based on regular time of play (including any stoppage
                time added by the referee) excluding extra time and penalty
                shootouts.
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.2</div>
              <div className="pl-3">
                Where matches are scheduled for play other than under regular time
                (e.g. Special time periods of play on various tournaments or
                friendly matches) all bets will be settled based on the final
                score at the end of that scheduled time.
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.3</div>
              <div className="pl-3">
                Unless non regular time matches are expressly indicated on the
                website prior to all football matches, bets taken on such matches
                will be considered VOID.
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.4</div>
              <div className="pl-3">
                If the status or outcome of a match posted on the official website
                is manifestly wrong, or where the match did not complete within
                the regular time, the Operator shall use its best endeavours to
                determine the correct status and outcome of the match. In any
                event where a match has not been completed within the scheduled
                regular time [regular time is defined as the scheduled total time
                playable including stoppage time indicated by the officials] the
                game shall be settled by the Operator as being incomplete. In such
                cases only those markets that have been unconditionally determined
                shall be settled. For all other markets, the bets shall be void
                and the stakes returned to the Player. The Operator shall settle
                such matches in accordance with these rules and the Operator's
                decision shall be final.
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.5</div>
              <div className="pl-3">
                These are the bets offered for Football. In Running ("Live")
                betting will be separately offered in the "Live" Section.
              </div>
            </li>
            <ol type="I">
              <li className="pt-2 pl-3">(I) 1X2</li>
              <li className="pt-2 pl-3">(II) Asian Handicap</li>
              <li className="pt-2 pl-3">
                (III) Clean Sheet
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) To predict if the team will keep a clean sheet and not
                    concede any goals in a designated match. (e.g. Team A beats
                    Team B 3-0, Team A have "kept a clean sheet" as they have not
                    conceded any goals)
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned, all bets will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IV) Correct Score - First Half &amp; Full Time
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) To win CORRECT SCORE, your chosen team (home or away) must
                    win by the correct result or score.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) To win CORRECT SCORE UP-5, your chosen team (home or away)
                    must win by a goal difference of 5 or more.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) To win AOS or "any other score", your chosen team (home or
                    away) must win by a result or score that is not quoted on the
                    market.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (V) Double Chance
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Bet on 2 of 3 possible outcomes from 3 options available
                    (e.g. Home Win or Draw (1X), Away Win or Draw (X2), Home Win
                    or Away Win (12)).
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If a match is played at a neutral ground, the bets will be
                    settled according to the match venue (Home/Away Team)
                    displayed on our website.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(VI) Fantasy Match</li>
              <li className="pt-2 pl-3">
                (VII) First Corner
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the team to receive the first corner in a
                    designated match with the regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned after the first corner is
                    awarded, all bets on First Corner will stand.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) If the match is abandoned before the first corner is
                    awarded, all bets on First Corner will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (VIII) First Goal / Last Goal / No Goal
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the First, Last, or No Goal after kickoff in the
                    designated match with regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Own goals count to the side credited with the goal. (E.g.
                    Team A vs Team B, Team B scores an own goal to make the score
                    1-0, the first goal will be awarded to Team A).
                  </li>
                  <li className="pt-2 pl-3">
                    (C) If a match is abandoned after a goal is scored, all bets
                    on the First Goal and No Goal will stand but all bets on Last
                    Goal will be refunded.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) If a match is abandoned without any goal, all bets on the
                    First, Last and No Goal will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IX) First / Last Offside
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the team to make the first/ last offside in the
                    designated match within the regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned after the first offside, all bets
                    on First Offside will stand, but all bets on Last Offside will
                    be refunded.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) If the match is abandoned before any offside is made, all
                    bets on First/ Last Offside will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (X) First/ Last Substitution
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict which of the two teams will make their first/ last
                    player substitution in the designated match within the regular
                    time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) In the event of more than two players being substituted at
                    the same time, the player number that is shown first by the
                    4th Official will be deemed the outcome.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) If the match is abandoned after first substitution has been
                    made, all bets on First Substitution will stand, but all bets
                    on Last Substitution will be refunded.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) If the match is abandoned before any substitution has been
                    made, all bets on First/ Last Substitution will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XI) First Yellow Card
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the team to receive the first yellow card in the
                    designated match within the regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the booking is a straight red card (professional foul),
                    it will be regarded as a red card but not a yellow card.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) In the event of two or more players receiving a booking
                    for the same incident, then the player who is shown the first
                    yellow card by the referee will be deemed the outcome.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) The yellow cards shown to non-player (e.g. substitute/
                    reserve, manager or coach) do not count.
                  </li>
                  <li className="pt-2 pl-3">
                    (E) If the match is abandoned after the first yellow card is
                    received, all bets on First Yellow Card will stand.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XII) Goalscorers
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the goal scorers in a designated match.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) The bet will be refunded if the selected player is not
                    played in the match.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) The bet stands if the selected player is fielded at any
                    time during the regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) Own goals and goals scored during Penalty Shootouts do not
                    count.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIII) Last Corner
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Predict the team to receive the last corner in a designated
                    match within regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If a match is abandoned within the regular time of play,
                    all bets on Last Corner will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XIV) Odd/Even</li>
              <li className="pt-2 pl-3">
                (XV) Outright
                <ol type="A">
                  <li className="pt-2 pl-3">(A) Top Goalscorer</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XVI) Over/Under</li>
              <li className="pt-2 pl-3">
                (XVII) Penalty Shootout
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Handicap
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) Penalty Handicap result includes sudden death.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Over/Under
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) Penalty Over/Under result does not include sudden
                        death and is based on 5 penalty kicks per team.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XVIII) Penalties Taken
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Prediction on penalty that is being awarded and taken in
                    the designated match with the regular time of play
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned after the penalty is awarded and
                    taken, all bets will stand.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) If the match is abandoned before the penalty is awarded and
                    taken, all bets will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIX) Period Betting
                <div className="pt-1">10 and 15 Minute Events</div>
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) A 10 and 15 minute Event bet is decided by the total number
                    of actions (Eg : goals, corners or bookings) in a match within
                    blocks of 10 or 15 minute periods during a game. (Eg :
                    00:00-15:00; 15:01-30:00)
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Timing of the action shall be determined by following the
                    official match time.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) Pending bets exceeding the specific period for betting will
                    be rejected and refunded.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) Re-taken actions are not included in the count.
                  </li>
                  <li className="pt-2 pl-3">
                    (E) Total Number of Bookings (Specific Sports Betting Rules
                    xxi) rule shall apply.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XX) Total Goal
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Total goal bets involve the prediction of the cumulative
                    total goals or points scored in a match in which the bets were
                    placed.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXI) Total Number of Bookings
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Only fours scored from the bat (off any delivery - legal or
                    not) will count towards the total fours. Overthrows, all run
                    fours and extras do not count.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Fours scored in a super over do not count.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) For first-class matches, only first innings fours will
                    count.
                    <ol type="i">
                      <li className="pt-2 pl-3">(i) 1 yellow card = 1 point</li>
                      <li className="pt-2 pl-3">(ii) 1 red card = 2 points</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (D) The maximum points count per player is 3 points; 1 point
                    for 1st yellow card and 2 points for red card, the 2nd yellow
                    card will not be counted.
                  </li>
                  <li className="pt-2 pl-3">
                    (E) If the match is abandoned within the regular time of play,
                    all bets on Total Bookings will be refunded.
                  </li>
                  <li className="pt-2 pl-3">
                    (F) Total Bookings result for the 1st Half will be decided once
                    the match official blows the whistle to end the 1st Half. Any
                    bookings made between the time the match official has blown the
                    whistle to end the 1st Half and the commencement of the 2nd
                    Half shall be accumulated towards the Total Bookings result for
                    the Full Time.
                  </li>
                  <li className="pt-2 pl-3">
                    (G) The Total Bookings result for the Full Time shall be
                    decided by the number of bookings accumulated until the full
                    time whistle is blown. Any bookings made after the full time
                    whistle has been blown shall be disregarded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXII) Total Number of Corners
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) The Number of Corners result is decided by the total number
                    of corners awarded to either the Home team, Away team or both
                    the Home and Away teams in a designated match (inclusive of
                    handicap, if any).
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Retaken corners are counted as one.
                  </li>
                  <li className="pt-2 pl-3">
                    (C) Corners awarded but untaken do not count.
                  </li>
                  <li className="pt-2 pl-3">
                    (D) All Total Corner bets on Asian Handicap and Over/Under
                    that are in Pending mode, will be cancelled if one of the
                    following occurs:
                    <ol type="1">
                      <li className="pt-2 pl-3">(1) a goal is scored; or</li>
                      <li className="pt-2 pl-3">(2) a player is sent off.</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIII) Total Number of Substitutions
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) The Total Number Substitution result is decided by the
                    total number of substitution of Home/Away teams that are made
                    within the designated match.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned within the regular time of play,
                    all bets on Total Number of Substitutions will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIV) Total Number of Offside
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) The Total Offside bets settlement will be made in a
                    designated match within the regular time of play.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) If the match is abandoned within the regular time of play,
                    all bets on Total Offside will be refunded.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXV) Home Team Total vs. Away Team Total
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Home Team Total vs. Away Team Total is decided by the total
                    number of goals scored by the home team against the total
                    number of goals scored by the away team in the league offered
                    for betting.
                  </li>
                  <li className="pt-2 pl-3">
                    (B) Home Team refers to the first team indicated on our
                    website. Away Team refers to the second team indicated on our
                    website.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVI) Total Team Goals
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) Total team goals is decided by the total number of goal
                    scored by a team in a match, eg: West Ham Total Goal -
                    (Over), or West Ham Total Goal (Under)
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVII) Next Action (Goal, Corner or Booking)
                <div className="pt-1">
                  This bet requires you to predict which team will be awarded the
                  next action in the match (Goal, Corner or Booking). If no action
                  is awarded, all bets will be refunded.
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>5.6</div>
              <div className="pl-3">
                Type A Scoring applies to the following products offered for live
                betting:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) 1X2</li>
              <li className="pt-2 pl-3">(B) Asian Handicap</li>
              <li className="pt-2 pl-3">(C) Odd/Even</li>
              <li className="pt-2 pl-3">(D) Over/Under</li>
              <li className="pt-2 pl-3">(E) Total Number of Corners</li>
              <li className="pt-2 pl-3">(F) Total Number of Bookings</li>
            </ol>
            <li className="flex pt-2">
              <div>5.7</div>
              <div className="pl-3">
                Type B Scoring applies to the following products offered for live
                betting:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) Match Winner</li>
              <li className="pt-2 pl-3">(B) Which team to qualify</li>
            </ol>
            <li className="flex pt-2">
              <div>5.8</div>
              <div className="pl-3">e-Football Betting</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Unless otherwise stated in this Rule 20.8, Rule 20 shall apply
                to e-Football bets.
              </li>
              <li className="pt-2 pl-3">
                (B) e-Football matches are simulations based on Artificial
                Intelligence, machine learning and historical football databases
                to reflect the team form and match play.
              </li>
              <li className="pt-2 pl-3">
                (C) Each match is played in two halves of 8 minutes each for a
                total match time of 16 minutes.
              </li>
              <li className="pt-2 pl-3">
                (D) The e-Football match results, scores and other bet determining
                data shall be those produced by the software and not available
                from any other source including from official team or league
                websites.
              </li>
              <li className="pt-2 pl-3">
                (E) e-Football matches are broadcast matches and as such are
                considered Common Betting matches where more than one End User is
                able to bet on a specific match and the result of this match will
                determine the outcome of bets placed by all End Users.
              </li>
              <li className="pt-2 pl-3">
                (F) Where any match is not completed within the scheduled time due
                to a technical malfunction of any sort, including but not
                exclusively computer, electronic, software, hardware or connection
                malfunctions, the match shall be settled by the Operator as being
                incomplete. In such cases only those bets that have been
                unconditionally determined shall be settled. For all other markets
                and irrespective of any indicative results, the bets shall be void
                and the stakes returned to the End User. The Operator shall settle
                such matches in accordance with these rules and the Operator's
                decision shall be final.
              </li>
              <li className="pt-2 pl-3">
                (G) The Operator reserves the right to declare an e-Football bet to
                be void if;
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) only partial or incorrect bet details are available;
                  </li>
                  <li className="pt-2 pl-3">
                    (II) the Operator has any suspicion that one or more End Users
                    are participating in fraud, collusion, money laundering or
                    other illegal activities;
                  </li>
                  <li className="pt-2 pl-3">
                    (III) the match did not commence or was not completed or the
                    result could not be determined;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) acceptance of the bet would exceed any betting limits;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) the stake amount is not available in the End User's
                    account;
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) an error (human or otherwise) or system failure results in
                    incorrect odds being used;
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) technical faults such as communication failures, defects,
                    interruptions, delays, viruses, denial of service attacks, or
                    data corruption occur; or
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) if a technical defect produces excessive or irregular
                    winnings.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) Should a bet be settled incorrectly due to error (human or
                otherwise) or system failure, the settlement will be deemed as
                invalid and will be reversed. Should the End User have insufficient
                funds in their account to allow this, the End User will be required
                to return the necessary amount to the Operator.
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. MUAY THAI</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>6.1</div>
              <div className="pl-3">
                The Red or Blue colours designated to fighters are strictly for
                reference purposes only. All bets will be considered valid
                regardless of any colour change of the fighters. In such an event
                the name of the fighter will be used to identify the winner of the
                event.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.2</div>
              <div className="pl-3">
                All bets will be void if one or both participants ("fighters") are
                disqualified by the judges or the referee either before or during
                the fight ("event"). All bets will also be void if one or both
                fighters are disqualified by the judges or the referee after the
                event has ended but before any decision has been announced.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.3</div>
              <div className="pl-3">
                An event is only considered to have started or commenced when the
                bell is sounded for the beginning of the first round. All bets will
                be void if one or both fighters fail to start the event.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.4</div>
              <div className="pl-3">
                All bets will be settled based on the official decision given in
                the ring immediately after the end of the event. Subsequent
                changes to the result are not recognized for betting purposes.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.5</div>
              <div className="pl-3">
                If there are any inconsistencies between the fighters' names in
                Thai and non-Thai used on the Website, the Thai version shall
                prevail.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.6</div>
              <div className="pl-3">
                The Operator reserves the right to refuse, reject or void without
                prior notification any bet where the Operator discovers or suspects
                that the outcome or the running of any event is subject to
                cheating, manipulation or fixing. Any attempted or actual act by
                the End User to cheat, manipulate or fix an event will lead to the
                termination of their account and/or their permanent barring from
                holding an Account, at the discretion of the Operator.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.7</div>
              <div className="pl-3">
                The Operator reserves the right to refuse, reject or void without
                prior notification any bet where the Operator discovers or suspects
                that the outcome or the running of any event is subject to
                cheating, manipulation or fixing. Any attempted or actual act by
                the End User to cheat, manipulate or fix an event will lead to the
                termination of their account and/or their permanent barring from
                holding an Account, at the discretion of the Operator.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.8</div>
              <div className="pl-3">
                All bets will be valid where the name of one or both fighters has
                been changed but the relevant fighter is the same person.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.9</div>
              <div className="pl-3">
                In the event that a bet contains errors in price or odds then such
                error must be reported to the Operator within twelve (12) hours
                from the acceptance of the bet. Any error reported after twelve
                (12) hours from the acceptance of the bet will not be considered.
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.10</div>
              <div className="pl-3">These are the bets offered for Muay Thai:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap — Asian Handicap bets relate to the winner
                    of the event. Where the event is declared a draw, all Asian
                    Handicap bets will be void.
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Over/Under — Over/Under bets relate to the sum total of
                    rounds which have been completed in the event. The ongoing
                    round during which the event is ended is not counted towards
                    the total sum of rounds. Therefore, if an event ends/knockout
                    in round 5 then the number of completed rounds is four (4). If
                    the event is decided by the judges after the fifth round is
                    ended based on points then the number of completed round is
                    five.
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap — Asian Handicap bets relate to the winner
                    of the event. Where the event is declared a draw, all Asian
                    Handicap bets will be void.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>6.11</div>
              <div className="pl-3">
                The Scoring System applicable to bets for Muay Thai is the Type B
                Scoring.
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. TABLE TENNIS</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                All bets will be VOID, if a match has not been completed due to a
                player's retirement or disqualification.
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                These are the bets offered for Table Tennis:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) Points Handicap</li>
                      <li className="pt-2 pl-3">(B) Sets Handicap</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Odd/Even
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Odd-Even bets relate to the sum total of points played
                        in the match resulting in an odd or even number.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) Outright</li>
                  <li className="pt-2 pl-3">
                    (IV) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Over/Under bets relate to the sum total of points
                        played in the match being over or under the prescribed
                        number of points set by the Operator.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) Scoring System
                <div className="pt-1">Type B Scoring applies.</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. TENNIS</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>8.1</div>
              <div className="pl-3">
                All bets will be VOID if a match has not been completed due to a
                player's retirement or disqualification, except for the following
                bets: First Ace, First Double Fault and Period betting (if these
                bets have been unconditionally determined).
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.2</div>
              <div className="pl-3">
                All bets will be VOID if the tournament is reduced in length,
                postponed or cancelled, except for those on markets which have been
                unconditionally determined.
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.3</div>
              <div className="pl-3">
                The total number of sets required to win a match is as determined
                by the official tournament organizers.
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.4</div>
              <div className="pl-3">
                The 12 Hours Rule does not apply to Tennis betting.
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.5</div>
              <div className="pl-3">
                All bets stand regardless of change of venue or course surface.
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.6</div>
              <div className="pl-3">These are the bets offered for Tennis:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) Points Handicap</li>
                      <li className="pt-2 pl-3">(B) Sets Handicap</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) First Ace
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the player who made the first Ace in the match
                        as per official match statistics.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) First Double Fault
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the player who made the first double fault in
                        the match as per official match statistics.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) Most Aces
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the player with the most Aces in the match as
                        per official match statistics.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) Most Double Fault
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Bet on the player who has the most double faults in the
                        match as per official match statistics.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) Odd/Even
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Odd/Even bets are settled based on the sum total of
                        games played in the match including the games added when a
                        match is Tie during match (if applicable) to resulting in
                        an odd or even number.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VII) Outright</li>
                  <li className="pt-2 pl-3">
                    (VIII) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Over/Under bets are settled based on the sum total of
                        games played by the end of the match including the games
                        played during a Tie (if applicable).
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) Period Betting
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets are settled based on the total number of games
                        played by the end of the set, including games played during
                        a Tie.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                  <li className="pt-2 pl-3">(II) Over/Under</li>
                  <li className="pt-2 pl-3">(III) Period Betting</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) Scoring System
                <div className="pt-1">Type B Scoring applies.</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. VOLLEYBALL</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                All bets will be VOID, if a match is not completed, except for
                Period Betting (if bets have been unconditionally determined).
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                Where the statutory number of sets in a game are changed (whether
                before or during a game) through the introduction of additional
                set(s) and/or Golden Set(s) or any other irregular format (for
                example during friendlies), such additional or Golden sets or
                irregular formats shall be ignored and all bets shall be settled
                based only on the results achieved during normal regular game play.
                These are the bets offered for Volleyball:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) Non Live Betting
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) Asian Handicap
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) Points Handicap</li>
                      <li className="pt-2 pl-3">(B) Sets Handicap</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) Odd/Even
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Odd/Even bets relate to the sum total of points played
                        in the match resulting in an odd or even number.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) Outright</li>
                  <li className="pt-2 pl-3">
                    (IV) Over/Under
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) Over/Under bets relate to the sum total of points
                        played in the match being over or under the prescribed
                        number of points set by the Operator.
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) Period Betting
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) All bets are settled based on the total points played
                        at the end of the period, including all points garnered
                        during deuce (where applicable).
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") Betting
                <ol type="I">
                  <li className="pt-2 pl-3">(I) Asian Handicap</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) Scoring System
                <div className="pt-1">Type B Scoring applies</div>
              </li>
            </ol>
          </ol>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">
            D. Bot & Automated Systems Policy
          </h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. Prohibition of Automated Systems</h3>
          <p className="pt-2">
            Users are strictly prohibited from using bots, scripts, automated
            software, AI agents, or any other automated tools to access,
            interact with, or perform activities on the Platform without the
            Company’s prior written authorization.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. Automated Betting and Transactions</h3>
          <p className="pt-2">
            Users must not use automated systems to place wagers, determine
            stakes, confirm bets, accept odds changes, or execute cash-outs
            without manual user confirmation through authorized interfaces. This
            prohibition includes software designed to simulate human clicks,
            keystrokes, or other interactions.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            3. Data Scraping and Automated Data Collection
          </h3>
          <p className="pt-2">
            Users are prohibited from employing web scrapers, crawlers, bots,
            scripts, or other automated tools to collect, copy, monitor, or
            extract data from the Platform, including but not limited to odds,
            betting markets, event results, account information, and transaction
            histories, unless expressly authorized by the Company.
          </p>
          <p className="pt-2">
            This restriction applies regardless of whether such activities are
            performed continuously, intermittently, or at a low frequency.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. Unauthorized API Access</h3>
          <p className="pt-2">
            Users must not access or utilize any API, endpoint, WebSocket, or
            internal communication interface that has not been officially made
            available by the Company. Technical accessibility of an endpoint
            does not constitute authorization to use it.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. Circumvention and Detection Evasion</h3>
          <p className="pt-2">
            Users must not employ any methods or tools intended to bypass
            security controls, rate limits, CAPTCHA, or bot detection
            mechanisms, including the use of multiple accounts, proxies, or
            alternative networks for the purpose of circumventing such
            restrictions.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. Third-Party Software and Services</h3>
          <p className="pt-2">
            Users are responsible for activities conducted through their
            accounts, including activities performed by authorized third parties
            or external software. The use of third-party services does not
            exempt users from the restrictions on automated activities under
            this Policy.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. Permitted Analytical Tools</h3>
          <p className="pt-2">
            Users may utilize analytical tools, statistical models, or
            AI-assisted decision-making systems, provided such tools do not
            access the Platform automatically without authorization, extract
            data in violation of this Policy, or execute wagers without manual
            user confirmation.
          </p>
          <p className="pt-2">
            Accessibility technologies and ordinary browser functionality are
            not prohibited solely because they provide automated assistance,
            provided they are not used to circumvent this Policy.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            8. Authorized Automation and API Integrations
          </h3>
          <p className="pt-2">
            The Company may authorize selected users or partners to access APIs
            or operate automated systems under a separate written agreement.
            Authorized users must comply with the specified access scope, usage
            limits, and technical requirements established by the Company.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. Monitoring and Investigation</h3>
          <p className="pt-2">
            The Company reserves the right to monitor usage patterns, access
            requests, wagering activities, and relevant technical information to
            identify unauthorized automation, in accordance with applicable
            privacy and data protection laws.
          </p>
          <p className="pt-2">
            The Company may temporarily restrict access where there are
            reasonable grounds to suspect a violation. Detection of unusual
            activity alone does not necessarily establish a confirmed breach.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">10. Violations and Enforcement</h3>
          <p className="pt-2">
            Where a violation of this Policy is established, the Company may
            take proportionate measures, subject to applicable laws and
            regulations, including:
          </p>
          <ul className="list-disc pl-6 pt-2 space-y-2">
            <li>Restricting or blocking automated access</li>
            <li>
              Limiting account privileges or temporarily suspending an account
            </li>
            <li>Reviewing affected wagers and related transactions</li>
            <li>
              Voiding wagers directly affected by the violation, where permitted
              by applicable law and betting rules
            </li>
            <li>
              Terminating services or closing an account following a confirmed
              material violation
            </li>
          </ul>
          <p className="pt-2">
            Account suspension or investigation does not automatically result in
            forfeiture of lawful account balances or winnings. Users may contact
            Customer Support to request clarification or appeal an enforcement
            decision.
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            11. Policy Interpretation and Applicable Law
          </h3>
          <p className="pt-2">
            This Policy forms part of the Company’s Terms and Conditions and
            shall be read together with its Betting Rules, Privacy Policy, and
            applicable laws. In the event of any conflict with mandatory legal
            or regulatory requirements, those requirements shall prevail.
          </p>
        </div>
      </section>
    </div>
  );
};

export default RulesContentEN;
